import _extends from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import styled from 'styled-components';
import styles from './StaffBlade.style';

// import slugify from 'url-slug';
import urlSlug from 'url-slug';
import Carousel from '../../molecules/Carousel';
import Heading from '../../atoms/Heading';
import Anchor from '../../atoms/Anchor';
import ImageTextCard from '../../molecules/ImageTextCard';
import breakPoints from '../../../themes/breakpoints';
import { fetchProperty, createLinkID } from '../../../utils/utilityFunction';
import constants, { siteConstants } from '../../../constants/globalConstants';
import { staffLabels } from '../../../constants/labels/en/';
import componentAnalytics from '../../../constants/analyticsConstants';
import RichText from '../../atoms/RichText/RichText';
import { imageRenditions, imageRenditionsVariationB, scrollableCarouselDesktopSettings } from './config';
import CarouselArrow from '../../atoms/CarouselArrow';
var StaffBladeBlock = styled.section.withConfig({
  componentId: "sc-2008dn-0"
})(["", ";"], styles);
var StaffBlade = /*#__PURE__*/function (_React$Component) {
  _inherits(StaffBlade, _React$Component);
  var _super = _createSuper(StaffBlade);
  function StaffBlade(props) {
    var _this;
    _classCallCheck(this, StaffBlade);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleMessageReceived", function (event) {
      if (typeof event.data === 'string') {
        var objMsg = JSON.parse(event.data);
        if (objMsg.type === 'ScreenSizeChanged') {
          _this.setState({
            key: _this.state.key + 1
          });
        }
      }
    });
    _this.state = {
      key: 0
    };
    return _this;
  }
  _createClass(StaffBlade, [{
    key: "getVariationDetails",
    value: function getVariationDetails(staffBladeData) {
      var variation = fetchProperty(staffBladeData, 'variation').toLowerCase();
      var totalBlades = this.getTotalBladeCount(staffBladeData);
      var appliedBladeClass = variation && variation === constants.variations.variationA.toLowerCase() ? 'three-blade' : 'five-blade';
      var bladePerRow = variation && variation === constants.variations.variationA.toLowerCase() ? 3 : 5;
      var totalRows = Math.ceil(totalBlades / bladePerRow);
      var headingType = variation && variation === constants.variations.variationA.toLowerCase() ? 'heading_three blade-heading' : 'heading_four blade-heading';
      var subHeadingType = variation && variation === constants.variations.variationA.toLowerCase() ? 'heading_four blade-subheading' : 'heading_five blade-subheading';
      var linkStyletype = variation && variation === constants.variations.variationA.toLowerCase() ? 'primary-anchor' : '';
      return {
        appliedBladeClass: appliedBladeClass,
        bladePerRow: bladePerRow,
        totalRows: totalRows,
        headingType: headingType,
        subHeadingType: subHeadingType,
        linkStyletype: linkStyletype
      };
    }
  }, {
    key: "getTotalBladeCount",
    value: function getTotalBladeCount(staffBladeData) {
      var tiles = staffBladeData && staffBladeData.staffCardCollection && staffBladeData.staffCardCollection.items && staffBladeData.staffCardCollection.items.length ? staffBladeData.staffCardCollection.items : [];
      if (tiles.length == 0) {
        tiles = staffBladeData && staffBladeData.staffCard && staffBladeData.staffCard.length ? staffBladeData.staffCard : [];
      }
      return tiles.length;
    }
  }, {
    key: "getMobileSettings",
    value: function getMobileSettings() {
      return {
        infinite: true,
        slidesToShow: 1,
        centerMode: false,
        rows: 1,
        slidesPerRow: 1,
        arrows: true,
        speed: 500,
        dots: true,
        slidesToScroll: 1
      };
    }
  }, {
    key: "getDesktopSettings",
    value: function getDesktopSettings(staffBladeData) {
      var _this$getVariationDet = this.getVariationDetails(staffBladeData),
        appliedBladeClass = _this$getVariationDet.appliedBladeClass,
        bladePerRow = _this$getVariationDet.bladePerRow,
        totalRows = _this$getVariationDet.totalRows;
      return {
        className: appliedBladeClass + '-slider',
        centerMode: false,
        infinite: false,
        slidesToShow: 1,
        rows: totalRows,
        slidesPerRow: bladePerRow
      };
    }
  }, {
    key: "getStaffCarouselSettings",
    value: function getStaffCarouselSettings(staffBladeData) {
      var desktopSettings = this.getDesktopSettings(staffBladeData);
      var mobileSettings = this.getMobileSettings();
      return _objectSpread(_objectSpread({}, desktopSettings), {}, {
        responsive: [{
          breakpoint: breakPoints.tabletL,
          settings: _objectSpread({}, mobileSettings)
        }]
      });
    }
  }, {
    key: "getScrollableCarouselSettings",
    value: function getScrollableCarouselSettings(staffBladeData) {
      var _this$getVariationDet2 = this.getVariationDetails(staffBladeData),
        appliedBladeClass = _this$getVariationDet2.appliedBladeClass;
      var desktopSettings = scrollableCarouselDesktopSettings(staffBladeData, appliedBladeClass);
      var mobileSettings = this.getMobileSettings();
      return _objectSpread(_objectSpread({}, desktopSettings), {}, {
        responsive: [{
          breakpoint: 1024,
          settings: _objectSpread({}, mobileSettings)
        }]
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('message', this.handleMessageReceived);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.handleMessageReceived);
    }
  }, {
    key: "render",
    value: function render() {
      var _staffBladeData$cta$s,
        _this2 = this;
      var staffBladeData = this.props.staffBladeData;
      var sysId = staffBladeData && staffBladeData.sys && staffBladeData.sys.id;
      var displayCarouselStaff = staffBladeData.staffCarouselScrollHorizontal && this.props.pageType != 'Staff';
      if (!staffBladeData) return null;
      var carouselSettings = displayCarouselStaff ? this.getScrollableCarouselSettings(staffBladeData) : this.getStaffCarouselSettings(staffBladeData);
      var _this$getVariationDet3 = this.getVariationDetails(staffBladeData),
        appliedBladeClass = _this$getVariationDet3.appliedBladeClass,
        headingType = _this$getVariationDet3.headingType,
        subHeadingType = _this$getVariationDet3.subHeadingType,
        linkStyletype = _this$getVariationDet3.linkStyletype;
      var tiles = staffBladeData && staffBladeData.staffCardCollection && staffBladeData.staffCardCollection.items ? staffBladeData.staffCardCollection.items : [];
      if (tiles.length == 0) {
        tiles = staffBladeData && staffBladeData.staffCard && staffBladeData.staffCard.length ? staffBladeData.staffCard : [];
      }
      var variation = fetchProperty(staffBladeData, 'variation').toLowerCase();
      var jumpLinkId = staffBladeData !== null && staffBladeData !== void 0 && staffBladeData.anchorLink ? staffBladeData === null || staffBladeData === void 0 ? void 0 : staffBladeData.anchorLink : createLinkID(staffBladeData === null || staffBladeData === void 0 ? void 0 : staffBladeData.sectionHeadline);
      var bodyContent = staffBladeData.bodyText && staffBladeData.bodyText.json;
      if (staffBladeData && staffBladeData.bodyText && staffBladeData.bodyText.bodyText) {
        bodyContent = staffBladeData.bodyText.bodyText;
      }
      var richTextEmbeddedAsset = staffBladeData.bodyText && staffBladeData.bodyText.links && staffBladeData.bodyText.links.assets.block || [];
      return __jsx(StaffBladeBlock, {
        className: "nva-staff-blade nva-staff-blade--".concat(variation, " ").concat(this.props.className),
        id: sysId
      }, __jsx("div", {
        className: "container"
      }, __jsx("div", {
        className: "col-xs-12 tile-wrapper"
      }, (staffBladeData === null || staffBladeData === void 0 ? void 0 : staffBladeData.sectionHeadline) && __jsx(Heading, {
        HeadingType: "h2",
        className: "nva-staff-blade__heading staff-heading",
        id: jumpLinkId
      }, staffBladeData === null || staffBladeData === void 0 ? void 0 : staffBladeData.sectionHeadline), staffBladeData.bodyText && __jsx(RichText, {
        className: "nva-staff-blade__description col-lg-8 col-sm-10 staff-description",
        jsonContent: bodyContent,
        richTextEmbeddedAsset: richTextEmbeddedAsset
      }), staffBladeData.cta && staffBladeData.cta.url && staffBladeData.cta.behavior && staffBladeData.cta.label && __jsx(Anchor, {
        "data-entry-id": (_staffBladeData$cta$s = staffBladeData.cta.sys) === null || _staffBladeData$cta$s === void 0 ? void 0 : _staffBladeData$cta$s.id,
        title: staffBladeData.cta.label,
        to: staffBladeData.cta.url,
        ctaBehavior: staffBladeData.cta.behavior,
        "aria-label": staffBladeData.cta.ariaLabel,
        hyperlinkType: staffBladeData.cta.hyperlinkType,
        className: "nva-staff-blade__cta secondary staff-top-cta",
        styleType: "primary-anchor",
        type: staffBladeData.cta.type,
        "data-analytics-type": componentAnalytics.staffBlade.analyticsType.STAFF_BLADE_CTA,
        "data-analytics-value": staffBladeData.cta.dataAnalyticsValue || '',
        "data-analytics-variation": staffBladeData.variation
      }, staffBladeData.cta.label), tiles.length && __jsx(Carousel, _extends({
        classes: {
          carousel: 'nva-staff-blade__carousel',
          allTilesContainer: 'nva-staff-blade__all-tiles-container'
        },
        key: this.state.key,
        styleType: "staffBladeCarousel"
      }, carouselSettings, {
        prevArrow: __jsx(CarouselArrow, {
          type: "previous"
        }),
        nextArrow: __jsx(CarouselArrow, {
          type: "next"
        })
      }), tiles.map(function (tileData, index) {
        var url = '';
        if (tileData.url) {
          url = "/staff/".concat(urlSlug(tileData.url));
        } else {
          url = "/staff/".concat(urlSlug(tileData.staffName)) || _this2.props.pageUrl && "".concat(_this2.props.pageUrl, "/").concat(urlSlug(tileData.staffName));
        }
        var imgSrc = tileData.staffImage && tileData.staffImage.image ? tileData.staffImage.image.url : '';
        if (!imgSrc || imgSrc == '') {
          imgSrc = tileData.staffImage && tileData.staffImage.image && tileData.staffImage.image.file ? tileData.staffImage.image.file.url : '';
        }
        var imgAltText = tileData.staffImage && tileData.staffImage.altText;
        var imgTitle = tileData.staffImage && (tileData.staffImage.title || tileData.staffImage.altText);
        if (typeof tileData.staffName !== 'string') {
          tileData.staffName = '';
        }
        var sysId = tileData.sys && tileData.sys.id;
        var displayStaffImage = displayCarouselStaff && tileData.hideOnStaffCarousel;
        return !displayStaffImage && __jsx(ImageTextCard, {
          sysId: sysId,
          key: index,
          styleType: "staff-blade",
          className: "nva-staff-blade__image-text-card ".concat(appliedBladeClass).concat(displayCarouselStaff ? ' scrollable is-scrollable' : ''),
          tileBackgroundColor: tileData.tileBackgroundColor,
          ariaLabel: tileData.staffName,
          paraText: tileData.staffName,
          subParaText: tileData.title,
          imageSource: imgSrc,
          imageAltText: imgAltText,
          imageTitle: imgTitle,
          descriptionType: siteConstants.RICH_TEXT,
          descriptionText: variation && variation === constants.variations.variationA.toLowerCase() ? tileData.shortBio && tileData.shortBio.json : '',
          variation: constants.variations.variationA.toLowerCase(),
          imageClassName: "blade-image",
          paraHeadingClassName: headingType,
          subParaClassName: subHeadingType,
          paraClassName: "blade-para",
          linkClassName: "blade-link",
          linkStyleType: linkStyletype,
          linkTitle: tileData.staffName,
          ctaSingle: {
            label: tileData.longBio && (tileData.createBioPage || tileData.createBioPage == null) ? staffLabels.VIEWPROFILE : '',
            url: url,
            hyperlinkType: tileData === null || tileData === void 0 ? void 0 : tileData.hyperlinkType,
            sys: tileData === null || tileData === void 0 ? void 0 : tileData.sys
          },
          dataAnalytics: {
            type: componentAnalytics.staffBlade.analyticsType.STAFF_CARD,
            value: tileData.staffName,
            variation: staffBladeData.variation
          },
          srcSetSetting: {
            imageRenditions: variation === constants.variations.variationA.toLowerCase() ? imageRenditions : imageRenditionsVariationB
          },
          donotLazyLoad: displayCarouselStaff
        });
      })))));
    }
  }]);
  return StaffBlade;
}(React.Component);
StaffBlade.defaultProps = {
  staffBladeData: '',
  inheritedstyles: {},
  className: ''
};
export default styled(StaffBlade).withConfig({
  componentId: "sc-2008dn-1"
})(["", ";"], styles);